import { testimonials } from '@/mocks/comics';

export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 mb-3">
            <i className="ri-heart-fill text-accent-500"></i> 读者口碑
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            他们都在看
          </h2>
          <p className="mt-2 text-sm text-foreground-600">来自真实读者的评价与推荐</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.slice(0, 3).map((t) => (
            <div
              key={t.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.author}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>

              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                  </span>
                ))}
              </div>

              <blockquote className="text-sm text-foreground-700 leading-relaxed flex-1">
                &ldquo;{t.content}&rdquo;
              </blockquote>

              <div className="mt-4 pt-4 border-t border-background-200/70">
                <span className="text-xs text-foreground-500">韩国漫画网读者</span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {testimonials.slice(3).map((t) => (
            <div
              key={t.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 flex gap-4"
            >
              <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
                <img
                  src={t.avatar}
                  alt={t.author}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-sm font-semibold text-foreground-950">{t.author}</span>
                  <span className="text-xs text-foreground-500">{t.role}</span>
                </div>
                <div className="flex gap-0.5 mb-2">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <span key={i} className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  &ldquo;{t.content}&rdquo;
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}